/**
 * Keycloak configuration for SSO
 */

const getKeycloakConfig = () => {
    const config = {
        url: process.env.REACT_APP_KEYCLOAK_URL || "https://dev.perfeqtfoods.com/keycloak/",
        realm: process.env.REACT_APP_KEYCLOAK_REALM || "CentralIAM",
        clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || "foodlabz-fe",
    };

    console.log("Keycloak config:", config);

    // Validate config
    if (!config.url || !config.realm || !config.clientId) {
        console.error("Keycloak config is incomplete:", config);
    }

    return config;
};

export default getKeycloakConfig;
